function base64UrlDecode(str: string): string {
    // Replace non-url compatible chars with base64 standard chars
    str = str.replace(/-/g, '+').replace(/_/g, '/');

    // Pad out with standard base64 required padding characters
    switch (str.length % 4) {
        case 0:
            break;
        case 2:
            str += '==';
            break;
        case 3:
            str += '=';
            break;
        default:
            throw new Error('Invalid base64url string!');
    }

    // Decode base64 string
    return Buffer.from(str, 'base64').toString();
}

// copied from jsonwebtoken npm pkg.  Didn't import to save size
export interface JwtHeader {
    alg: string | Algorithm;
    typ?: string;
    cty?: string;
    crit?: Array<string | Exclude<keyof JwtHeader, 'crit'>>;
    kid?: string;
    jku?: string;
    x5u?: string | string[];
    'x5t#S256'?: string;
    x5t?: string;
    x5c?: string | string[];
}

// copied from jsonwebtoken npm pkg.  Didn't import to save size
export interface JwtPayload {
    iss?: string;
    sub?: string;
    aud?: string | string[];
    exp?: number;
    nbf?: number;
    iat?: number;
    jti?: string;
}

export function decodeJwt<T>(token?: string): {
    header: JwtHeader;
    // copied from jsonwebtoken npm pkg.  Didn't import to save size
    payload: string | (JwtPayload & T);
} | null {
    try {
        if (!token) {
            /* HCP-700 removing the custom error to make sure it does not show up on sentry logs */
            return null;
        }

        const parts = token.split('.');

        if (parts.length !== 3) {
            throw new Error('JWT must have 3 parts');
        }

        const header = JSON.parse(base64UrlDecode(parts[0]));
        const payload = JSON.parse(base64UrlDecode(parts[1]));
        // const signature = JSON.parse(base64UrlDecode(parts[2]));
        // The signature is the third part, but we don't need to decode it to get the payload

        return { header, payload };
    } catch (error) {
        console.error('error decoding JWT:', error);
        return null;
    }
}

export function firstEight(value: string | null | undefined): string {
    return value ? value.substring(0, 8) : '<undfnd>';
}
